import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ios-button',
  templateUrl: './ios-button.component.html'
})
export class IosButtonComponent implements OnInit {
  constructor() { }

  ngOnInit() {

  }

}
